module.exports = __webpack_public_path__ + "static/logrosLogo-e0a0c6f9a2fbe982c42a2d9d80954935.svg";